// //////////////////////////////////////////////////
// /////////  DEP RECATED DO NOT USE   //////////////
// ////////   FAILED PATTERN: TOO COMPLEX    ////////
// /////////////////////////////////////////////////
const routes = {
  organizationList: '/app/organizations',
  organizationsPage: '/app/organizations',
  organization: {
    dashboard: '/app/organizations/dashboard',
    segments: '/app/organizations/segments',
    segmentsForm: '/app/organizations/segments/:id', // used in the router
    segmentsFormRoute: '/app/organizations/segments/', // used in links so id can be appended
    list: '/app/organizations/list',
    analytics: '/app/organizations/analytics',
    board: '/app/organizations/board',
  },

  accountsPage: '/app/accounts',
  account: {
    dashboard: '/app/accounts/dashboard',
    segments: '/app/accounts/segments',
    segmentsForm: '/app/accounts/segments/:id', // used in the router
    segmentsFormRoute: '/app/accounts/segments/', // used in links so id can be appended
    list: '/app/accounts/list',
    analytics: '/app/accounts/analytics',
    board: '/app/accounts/board',
  },

  contactsPage: '/app/contacts',
  contact: {
    dashboard: '/app/contacts/dashboard',
    segments: '/app/contacts/segments',
    segmentsForm: '/app/contacts/segments/:id', // used in the router
    segmentsFormRoute: '/app/contacts/segments/', // used in links so id can be appended
    list: '/app/contacts/list',
    analytics: '/app/contacts/analytics',
    board: '/app/contacts/board',
  },

  pipelinesPage: '/app/pipelines',
  pipeline: {
    dashboard: '/app/pipelines/dashboard',
    segments: '/app/pipelines/segments',
    segmentsForm: '/app/pipelines/segments/:id', // used in the router
    segmentsFormRoute: '/app/pipelines/segments/', // used in links so id can be appended
    list: '/app/pipelines/list',
    analytics: '/app/pipelines/analytics',
    board: '/app/pipelines/board',
  },

  productList: '/app/products',
  surveyList: '/app/surveys',
  surveyEditor: '/app/surveys/editor',
  dataManagementPage: '/app/settings/data-management',

  analyticsManagementPage: '/app/settings/analytics-management',

  campaigns: {
    templatesList: '/app/campaigns/email-templates',
    subscription: '/app/campaigns/subscriptions',
    metrics: '/app/campaigns/metrics',
    metricsList: '/app/campaigns/metrics/list',
    metricsPerformance: '/app/campaigns/metrics/performance/:id',
    metricsRecipients: '/app/campaigns/metrics/recipients/:id',
  },

  settingsPage: 'app/settings',
  settings: {
    dataManagement: {
      organization: '/app/settings/data-management/organization',
      account: '/app/settings/data-management/account',
      product: '/app/settings/data-management/product',
      event: '/app/settings/data-management/event',
      contact: '/app/settings/data-management/contact',
      currency: '/app/settings/data-management/currency',
    },
  },

  userManagementPage: '/app/user-management',
  loginManagement: {
    login: '/',
    activateAccount: '/activate-account',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
    accountLocked: '/locked',
    mfa: '/mfa',
    changePassword: '/change-password',
    completeProfile: '/app/complete-profile',
    selectWorkspace: '/select-workspace',
    ssoLogin: '/sso-login',
  },
  homePage: {
    default: '/app/cockpit',
    viewer: '/app/organizations/list',
  },
};

export default routes;
